import AddressService from '../services/patientAddress.service';

const patientAddress = {
  namespaced: true,

  state: {},

  mutations: {},

  actions: {
    get(_, patientId) {
      return AddressService.get(patientId);
    },
    one(_, { patientId, addressId }) {
      return AddressService.one(patientId, addressId);
    },
    create(_, address) {
      return AddressService.create(address);
    },
    update(_, address) {
      return AddressService.update(address);
    },
    remove(_, { patientId, addressId }) {
      return AddressService.remove(patientId, addressId);
    },
    getByCep(_, cep) {
      return AddressService.getByCep(cep);
    },
  },

  getters: {},
};

export default patientAddress;
